<template>
  <div class="oring-assistant-details-design">
    <div class="oring-assistant-details-design__buttons">
      <ReactiveButton
        :is-primary-button="false"
        @click="openConstructionPopup('download')"
        :button-text="$tv('Frontend.PdfDownload.DownloadPdf', 'ORingConfiguratorImport')"
      />
      <ReactiveButton
        :is-primary-button="false"
        @click="openConstructionPopup('send')"
        :button-text="$tv('Frontend.TranslationContactSend', 'ORingConfiguratorImport')"
      />
    </div>
    <h2 v-if="props.showHeaders">
      {{ i18n.tv('Frontend.Title.Result.ExpertMode', 'ORingConfiguratorImport') }}
    </h2>
    <div
      v-if="props.showHeaders"
      class="oring-assistant-details-design__label"
      v-tv:ORingConfiguratorImport="'Frontend.Wizard.OnlyIndustry'"
    />
    <h3
      v-if="props.showHeaders"
      class="general-header"
    >
      {{ i18n.tv('generalHeader', 'ORingConfigurator') }}
    </h3>
    <div
      v-if="props.showHeaders"
      class="oring-assistant-details-design__generalInfo"
    >
      <div>
        <div
          class="oring-assistant-details-design__generalInfo__label"
          v-tv:ORingConfiguratorImport="'Frontend.Report.Application'"
        />
        <div class="oring-assistant-details-design__generalInfo__value">
          {{ applicationString }}
        </div>
      </div>
      <div>
        <div
          class="oring-assistant-details-design__generalInfo__label"
          v-tv:ORingConfiguratorImport="'Frontend.Title.RingCompression'"
        />
        <div class="oring-assistant-details-design__generalInfo__value">
          {{ sealingCompressionString }}
        </div>
      </div>
    </div>
    <h3 class="construction-rating">
      {{ i18n.tv('Frontend.Subtitle.Rating', 'ORingConfiguratorImport') }}
    </h3>
    <div class="table">
      <!-- Desktop Table View -->
      <table class="oring-table desktop-only">
        <thead>
          <tr>
            <th />
            <th>{{ i18n.tv('Frontend.Parameter.Min', 'ORingConfiguratorImport') }}</th>
            <th>{{ i18n.tv('Frontend.Parameter.Target', 'ORingConfiguratorImport') }}</th>
            <th>{{ i18n.tv('Frontend.Parameter.Mean', 'ORingConfiguratorImport') }}</th>
            <th>{{ i18n.tv('Frontend.Parameter.Target', 'ORingConfiguratorImport') }}</th>
            <th>{{ i18n.tv('Frontend.Parameter.Max', 'ORingConfiguratorImport') }}</th>
            <th>{{ i18n.tv('Frontend.Parameter.Target', 'ORingConfiguratorImport') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in constructionTableRows"
            :key="row.label"
          >
            <td>{{ row.label }}</td>
            <td :class="row.minColorClass">
              {{ row.min }}
            </td>
            <td class="divider">
              {{ row.target1 }}
            </td>
            <td :class="row.meanColorClass">
              {{ row.mean }}
            </td>
            <td class="divider">
              {{ row.target2 }}
            </td>
            <td :class="row.maxColorClass">
              {{ row.max }}
            </td>
            <td>{{ row.target3 }}</td>
          </tr>
        </tbody>
      </table>
      <!-- Mobile Card View -->
      <div class="mobile-cards mobile-only">
        <div class="mobile-card">
          <div class="mobile-card__content">
            <div
              v-for="row in constructionTableRows"
              :key="row.label"
              class="mobile-card__section"
            >
              <h5 class="mobile-card__section-title">
                {{ row.label }}
              </h5>
              <div class="mobile-card__row">
                <span class="mobile-card__label">{{ i18n.tv('Frontend.Parameter.Min', 'ORingConfiguratorImport') }}</span>
                <span
                  class="mobile-card__value"
                  :class="row.minColorClass"
                >{{ row.min || '-' }}</span>
                <span />
                <span class="mobile-card__label">{{ i18n.tv('Frontend.Parameter.Target', 'ORingConfiguratorImport') }}</span>
                <span class="mobile-card__value">{{ row.target1 || '-' }}</span>
              </div>
              <div class="mobile-card__row">
                <span class="mobile-card__label">{{ i18n.tv('Frontend.Parameter.Mean', 'ORingConfiguratorImport') }}</span>
                <span
                  class="mobile-card__value"
                  :class="row.meanColorClass"
                >{{ row.mean || '-' }}</span>
                <span />
                <span class="mobile-card__label">{{ i18n.tv('Frontend.Parameter.Target', 'ORingConfiguratorImport') }}</span>
                <span class="mobile-card__value">{{ row.target2 || '-' }}</span>
              </div>
              <div class="mobile-card__row">
                <span class="mobile-card__label">{{ i18n.tv('Frontend.Parameter.Max', 'ORingConfiguratorImport') }}</span>
                <span
                  class="mobile-card__value"
                  :class="row.maxColorClass"
                >{{ row.max || '-' }}</span>
                <span />
                <span class="mobile-card__label">{{ i18n.tv('Frontend.Parameter.Target', 'ORingConfiguratorImport') }}</span>
                <span class="mobile-card__value">{{ row.target3 || '-' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h3>{{ i18n.tv('Frontend.Subtitle.Properties', 'ORingConfiguratorImport') }}</h3>
    <div class="table">
      <!-- Desktop Table View -->
      <table class="oring-table half-width desktop-only">
        <thead>
          <tr>
            <th />
            <th>{{ i18n.tv('Frontend.Parameter.Min', 'ORingConfiguratorImport') }}</th>
            <th>{{ i18n.tv('Frontend.Parameter.Mean', 'ORingConfiguratorImport') }}</th>
            <th>{{ i18n.tv('Frontend.Parameter.Max', 'ORingConfiguratorImport') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in propertiesTableRowsPart1"
            :key="row.label"
          >
            <td>{{ row.label }}</td>
            <td>{{ row.min }}</td>
            <td>{{ row.mean }}</td>
            <td>{{ row.max }}</td>
          </tr>
        </tbody>
      </table>
      <table class="oring-table half-width desktop-only">
        <thead>
          <tr>
            <th />
            <th>{{ i18n.tv('Frontend.Parameter.Min', 'ORingConfiguratorImport') }}</th>
            <th>{{ i18n.tv('Frontend.Parameter.Mean', 'ORingConfiguratorImport') }}</th>
            <th>{{ i18n.tv('Frontend.Parameter.Max', 'ORingConfiguratorImport') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in propertiesTableRowsPart2"
            :key="row.label"
          >
            <td>{{ row.label }}</td>
            <td>{{ row.min }}</td>
            <td>{{ row.mean }}</td>
            <td>{{ row.max }}</td>
          </tr>
        </tbody>
      </table>
      <!-- Mobile Card View -->
      <div class="mobile-cards mobile-only">
        <div class="mobile-card">
          <div class="mobile-card__content">
            <div
              v-for="row in [...propertiesTableRowsPart1, ...propertiesTableRowsPart2]"
              :key="row.label"
              class="mobile-card__section"
            >
              <h5 class="mobile-card__section-title">
                {{ row.label }}
              </h5>
              <div class="mobile-card__row--vertical">
                <div class="mobile-card__row-item">
                  <span class="mobile-card__label mobile-card__label--properties">{{ i18n.tv('Frontend.Parameter.Min', 'ORingConfiguratorImport') }}</span>
                  <span class="mobile-card__value">{{ row.min || '-' }}</span>
                </div>
                <div class="mobile-card__row-item">
                  <span class="mobile-card__label mobile-card__label--properties">{{ i18n.tv('Frontend.Parameter.Mean', 'ORingConfiguratorImport') }}</span>
                  <span class="mobile-card__value">{{ row.mean || '-' }}</span>
                </div>
                <div class="mobile-card__row-item">
                  <span class="mobile-card__label mobile-card__label--properties">{{ i18n.tv('Frontend.Parameter.Max', 'ORingConfiguratorImport') }}</span>
                  <span class="mobile-card__value">{{ row.max || '-' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h3>{{ i18n.tv('Frontend.Subtitle.Necessities', 'ORingConfiguratorImport') }}</h3>
    <div class="table">
      <!-- Desktop Table View -->
      <table class="oring-table third-width desktop-only">
        <thead>
          <tr>
            <th />
            <th>{{ i18n.tv('Frontend.Parameter.Ra', 'ORingConfiguratorImport') }}</th>
            <th>{{ i18n.tv('Frontend.Parameter.Rz', 'ORingConfiguratorImport') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in necessitiesTableRows"
            :key="row.label"
          >
            <td>{{ row.label }}</td>
            <td>{{ row.ra }}</td>
            <td>{{ row.rz }}</td>
          </tr>
        </tbody>
      </table>
      <!-- Mobile Card View -->
      <div class="mobile-cards mobile-only">
        <div class="mobile-card">
          <div class="mobile-card__content">
            <div
              v-for="row in necessitiesTableRows"
              :key="row.label"
              class="mobile-card__section"
            >
              <h5 class="mobile-card__section-title">
                {{ row.label }}
              </h5>
              <div class="mobile-card__row--vertical">
                <div class="mobile-card__row-item">
                  <span class="mobile-card__label mobile-card__label--properties">{{ i18n.tv('Frontend.Parameter.Ra', 'ORingConfiguratorImport') }}</span>
                  <span class="mobile-card__value">{{ row.ra || '-' }}</span>
                </div>
                <div class="mobile-card__row-item">
                  <span class="mobile-card__label mobile-card__label--properties">{{ i18n.tv('Frontend.Parameter.Rz', 'ORingConfiguratorImport') }}</span>
                  <span class="mobile-card__value">{{ row.rz || '-' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="oring-assistant-details-design__referenceText">
      <p v-html="i18n.tv('Frontend.ExpertMode.ReferenceText', 'ORingConfiguratorImport')" />
      <p>
        {{ referenceText2BeforeLink }}
        <NuxtLink
          :to="localePath('/oring-calculator/material-assistant')"
          class="oring-assistant-details-design__referenceText__link"
        >
          {{ materialAssistantText }}
        </NuxtLink>
        {{ referenceText2AfterLink }}
      </p>
    </div>
    <PopupORingConstruction
      :show="showConstructionPopup"
      :mode="constructionPopupMode"
      :on-submit="onConstructionSubmit"
      @close-pop-up="closeConstructionPopup"
    />
  </div>
</template>

<script setup lang="ts">
import {onMounted, ref, computed, watch} from 'vue'
import {useORingCalculatorStore} from '@/store/oring-calculator'
import {useOringCalculatorService} from '~/composables/oring_calc_service'
import useI18nExtended from '~/composables/usei18nExtended'
import {handleConstructionSubmit} from '@/composables/oring-helper'
import PopupORingConstruction from '~/components/popup/PopupORingConstruction.vue'

const dropdownInfo = ref<any>(null)

const i18n = useI18nExtended()
const oringStore = useORingCalculatorStore()
const {getConstructionViewDetailsORingConfigurator, getDropdownInfoORingConfigurator} = useOringCalculatorService()

const {oringAssistantConstructionView, oringCalculatorImperial} = storeToRefs(oringStore)

const props = defineProps({
  showHeaders: {
    type: Boolean,
    default: true
  }
})

onMounted(async () => {
  loadData()
})

const loadData = async () => {
  const constructionRequest = oringStore.oringIsAssistantDetails ? oringStore.oringAssistantConstructionViewRequest() :  oringStore.oringDesignCockpitConstructionViewRequest()
  if (props.showHeaders) {
    oringAssistantConstructionView.value = await getConstructionViewDetailsORingConfigurator(constructionRequest)
    dropdownInfo.value = await getDropdownInfoORingConfigurator({language: i18n.locale.value === 'de' ? 'de' : 'en'})
  }
}

const applicationString = computed(() => {
  return dropdownInfo.value?.applications?.find((item: any) => item.applicationId === oringAssistantConstructionView.value?.expertHousing?.applicationId)?.description || ''
})

const expertHousing = computed(() => {
  if (props.showHeaders) {
    return oringAssistantConstructionView.value?.expertHousing
  } else {
    // For design cockpit, we might not have expertHousing
    return oringStore.oringDesignCockpitCurrentHousing
  }
})

const sealingCompressionString = computed(() => {
  return dropdownInfo.value?.geometries?.find((item: any) => item.geometryID === oringAssistantConstructionView.value?.expertHousing?.geometryId)?.description || ''
})

const currentLengthUnit = computed(() => {
  return oringCalculatorImperial.value
    ? i18n.tv('inch', 'ORingConfigurator')
    : i18n.tv('mm', 'ORingConfigurator')
})

const currentVolumeUnit = computed(() => {
  return oringCalculatorImperial.value ? 'in³' : 'mm³'
})

const currentAreaUnit = computed(() => {
  return oringCalculatorImperial.value ? 'in²' : 'mm²'
})

const currentMicronUnit = computed(() => {
  return oringCalculatorImperial.value ? 'µin' : 'µm'
})

const nrOfDecimalPoints = computed(() => {
  return oringCalculatorImperial.value ? 4 : 2
})

const stripShy = (label: string) => label.replace(/\u00AD|&shy;/g, '')

const getColorClass = (rating: number): string => {
  switch (rating) {
  case 0: return 'rating-red'
  case 1: return 'rating-yellow'
  case 2: return 'rating-green'
  default: return ''
  }
}

const constructionTableRows = computed(() => {
  if (!expertHousing.value) { return [] }
  let rows = []
  if (oringStore.oringAssistantGeometryId === 9 || oringStore.oringAssistantGeometryId === 12) {
    rows.push({
      label: stripShy(i18n.tv('Frontend.Parameter.Stretching', 'ORingConfiguratorImport')),
      min: formatNumber(expertHousing.value?.stretching?.valueMin, '%', 1),
      minColorClass: getColorClass(expertHousing.value?.stretching?.minColorRating),
      target1: formatNumber(expertHousing.value?.stretching?.minCriterion, '%', 1) + (expertHousing.value?.stretching?.minCriterion ? ' **' : ''),
      mean: formatNumber(expertHousing.value?.stretching?.valueMean, '%', 1),
      meanColorClass: getColorClass(expertHousing.value?.stretching?.meanColorRating),
      target2: formatNumber(expertHousing.value?.stretching?.meanCriterion, '%', 1),
      max: formatNumber(expertHousing.value?.stretching?.valueMax, '%', 1),
      maxColorClass: getColorClass(expertHousing.value?.stretching?.maxColorRating),
      target3: formatNumber(expertHousing.value?.stretching?.maxCriterion, '%', 1) + (expertHousing.value?.stretching?.maxCriterion ? ' **' : '')
    })
  }

  if (oringStore.oringAssistantGeometryId === 8 || oringStore.oringAssistantGeometryId === 12) {
    rows.push({
      label: stripShy(i18n.tv('Frontend.Parameter.HoldingRatio', 'ORingConfiguratorImport')),
      min: formatNumber(expertHousing.value?.holdingRatio?.valueMin, '%', 1),
      minColorClass: getColorClass(expertHousing.value?.holdingRatio?.minColorRating),
      target1: formatNumber(expertHousing.value?.holdingRatio?.minCriterion, '%', 1) + (expertHousing.value?.holdingRatio?.minCriterion ? ' **' : ''),
      mean: formatNumber(expertHousing.value?.holdingRatio?.valueMean, '%', 1),
      meanColorClass: getColorClass(expertHousing.value?.holdingRatio?.meanColorRating),
      target2: formatNumber(expertHousing.value?.holdingRatio?.meanCriterion, '%', 1),
      max: formatNumber(expertHousing.value?.holdingRatio?.valueMax, '%', 1),
      maxColorClass: getColorClass(expertHousing.value?.holdingRatio?.maxColorRating),
      target3: formatNumber(expertHousing.value?.holdingRatio?.maxCriterion, '%', 1) + (expertHousing.value?.holdingRatio?.maxCriterion ? ' **' : '')
    })
  }

  rows.push({
    label: stripShy(i18n.tv('Frontend.Parameter.Compression', 'ORingConfiguratorImport')),
    min: formatNumber(expertHousing.value?.compression?.valueMin, '%', 1),
    minColorClass: getColorClass(expertHousing.value?.compression?.minColorRating),
    target1: formatNumber(expertHousing.value?.compression?.minCriterion, '%', 1) + (expertHousing.value?.compression?.minCriterion ? ' *' : ''),
    mean: formatNumber(expertHousing.value?.compression?.valueMean, '%', 1),
    meanColorClass: getColorClass(expertHousing.value?.compression?.meanColorRating),
    target2: formatNumber(expertHousing.value?.compression?.meanCriterion, '%', 1),
    max: formatNumber(expertHousing.value?.compression?.valueMax, '%', 1),
    maxColorClass: getColorClass(expertHousing.value?.compression?.maxColorRating),
    target3: formatNumber(expertHousing.value?.compression?.maxCriterion, '%', 1) + (expertHousing.value?.compression?.maxCriterion ? ' *' : '')
  })

  rows.push({
    label: stripShy(i18n.tv('Frontend.Parameter.FillingRatio', 'ORingConfiguratorImport')),
    min: formatNumber(expertHousing.value?.fillingRatio?.valueMin, '%', 1),
    minColorClass: getColorClass(expertHousing.value?.fillingRatio?.minColorRating),
    target1: formatNumber(expertHousing.value?.fillingRatio?.minCriterion, '%', 1),
    mean: formatNumber(expertHousing.value?.fillingRatio?.valueMean, '%', 1),
    meanColorClass: getColorClass(expertHousing.value?.fillingRatio?.meanColorRating),
    target2: formatNumber(expertHousing.value?.fillingRatio?.meanCriterion, '%', 1) + (expertHousing.value?.fillingRatio?.meanCriterion ? ' **' : ''),
    max: formatNumber(expertHousing.value?.fillingRatio?.valueMax, '%', 1),
    maxColorClass: getColorClass(expertHousing.value?.fillingRatio?.maxColorRating),
    target3: formatNumber(expertHousing.value?.fillingRatio?.maxCriterion, '%', 1) + (expertHousing.value?.fillingRatio?.maxCriterion ? ' *' : '')
  })

  return rows
})

const propertiesTableRowsPart1 = computed(() => {
  if (!expertHousing.value) { return [] }
  return [
    {
      label: stripShy(i18n.tv('Frontend.Parameter.CentralGap', 'ORingConfiguratorImport')),
      min: formatNumber(expertHousing.value?.centralGapWidth?.valueMin, currentLengthUnit.value, nrOfDecimalPoints.value),
      mean: formatNumber(expertHousing.value?.centralGapWidth?.valueMean, currentLengthUnit.value, nrOfDecimalPoints.value),
      max: formatNumber(expertHousing.value?.centralGapWidth?.valueMax, currentLengthUnit.value, nrOfDecimalPoints.value)
    },
    {
      label: stripShy(i18n.tv('Frontend.Parameter.AxialChamfer', 'ORingConfiguratorImport')),
      min: '',
      mean: '',
      max: formatNumber(expertHousing.value?.chamferLength?.valueMax, currentLengthUnit.value, nrOfDecimalPoints.value)
    }
  ]
})

const propertiesTableRowsPart2 = computed(() => {
  if (!expertHousing.value) { return [] }
  return [
    {
      label: stripShy(i18n.tv('Frontend.Parameter.RingVolume', 'ORingConfiguratorImport')),
      min: formatNumber(expertHousing.value?.ringVolume?.valueMin, currentVolumeUnit.value, nrOfDecimalPoints.value),
      mean: formatNumber(expertHousing.value?.ringVolume?.valueMean, currentVolumeUnit.value, nrOfDecimalPoints.value),
      max: formatNumber(expertHousing.value?.ringVolume?.valueMax, currentVolumeUnit.value, nrOfDecimalPoints.value)
    },
    {
      label: stripShy(i18n.tv('Frontend.Parameter.RingSurface', 'ORingConfiguratorImport')),
      min: formatNumber(expertHousing.value?.ringSurface?.valueMin, currentAreaUnit.value, nrOfDecimalPoints.value),
      mean: formatNumber(expertHousing.value?.ringSurface?.valueMean, currentAreaUnit.value, nrOfDecimalPoints.value),
      max: formatNumber(expertHousing.value?.ringSurface?.valueMax, currentAreaUnit.value, nrOfDecimalPoints.value)
    }
  ]
})

const necessitiesTableRows = computed(() => {
  if (!expertHousing.value) { return [] }
  return [
    {
      label: stripShy(i18n.tv('Frontend.Parameter.LeadInChamfer', 'ORingConfiguratorImport')),
      ra: formatNumber(expertHousing.value?.leadInChamfer?.ra, currentMicronUnit.value, 1),
      rz: formatNumber(expertHousing.value?.leadInChamfer?.rz, currentMicronUnit.value, 1)
    },
    {
      label: stripShy(i18n.tv('Frontend.Parameter.SideSurface', 'ORingConfiguratorImport')),
      ra: formatNumber(expertHousing.value?.sideSurface?.ra, currentMicronUnit.value, 1),
      rz: formatNumber(expertHousing.value?.sideSurface?.rz, currentMicronUnit.value, 1)
    },
    {
      label: stripShy(i18n.tv('Frontend.Parameter.StaticSealingSurface', 'ORingConfiguratorImport')),
      ra: formatNumber(expertHousing.value?.staticSealingSurface?.ra, currentMicronUnit.value, 1),
      rz: formatNumber(expertHousing.value?.staticSealingSurface?.rz, currentMicronUnit.value, 1)
    }
  ]
})

const formatNumber = (number: number, unit: string, decimalPoints: number = 2) => {
  if (isNaN(number) || number === 0) {
    return ''
  }
  const unitString = unit ? ` ${unit}` : ''
  return parseFloat(number.toFixed(decimalPoints)) + unitString
}

const referenceText2BeforeLink = computed(() => {
  const fullText = i18n.tv('Frontend.ExpertMode.ReferenceText2', 'ORingConfiguratorImport')
  const match = fullText.match(/^(.*?)<span>/)
  return match ? match[1] : fullText
})

const materialAssistantText = computed(() => {
  const fullText = i18n.tv('Frontend.ExpertMode.ReferenceText2', 'ORingConfiguratorImport')
  const match = fullText.match(/<span>(.*?)<\/span>/)
  return match ? match[1] : 'material assistant'
})

const referenceText2AfterLink = computed(() => {
  const fullText = i18n.tv('Frontend.ExpertMode.ReferenceText2', 'ORingConfiguratorImport')
  const match = fullText.match(/<\/span>(.*)$/)
  return match ? match[1] : ''
})

const showConstructionPopup = ref(false)
const constructionPopupMode = ref<'download' | 'send' | undefined>(undefined)

const openConstructionPopup = (mode: 'download' | 'send') => {
  constructionPopupMode.value = mode
  showConstructionPopup.value = true
}

const closeConstructionPopup = () => {
  showConstructionPopup.value = false
  constructionPopupMode.value = undefined
}

const onConstructionSubmit = async (popupData: any) => {
  await handleConstructionSubmit({
    mode: popupData.mode, // 'download' or 'send'
    popupData,
    housingType: props.showHeaders ? 'assistant' : 'cockpit',
    customHousingData: props.showHeaders ? expertHousing.value : null
  })
}

watch([
  () => i18n.locale.value
], () => {
  loadData()
})
</script>

<style scoped lang="scss">
.oring-assistant-details-design {
  font-weight: $base-text-font-weight-light;

  .general-header {
    @include breakpoint-down($md) {
      margin: 1rem 0;
    }
  }

  h2 {
    margin: 2rem 0 1rem;

    @include breakpoint-down($md) {
      margin: 1rem 0;
    }
  }

  h3 {
    margin: 2rem 0 .625rem;

    @include breakpoint-down($md) {
      margin: 2rem 0 1rem;
    }
  }

  &__buttons {
    display: flex;
    gap: 1rem;

    .k-button {
      @include breakpoint-down($md) {
        width: 9.5rem;
        min-width: auto;
      }
    }
  }

  &__generalInfo {
    display: flex;
    gap: 2rem;

    @include breakpoint-down($sm) {
      justify-content: space-between;
    }

    &__value {
      width: 11.5rem;
      font-weight: $base-text-font-weight-semi-bold;

      @include breakpoint-down($sm) {
        width: auto;
      }
    }
  }

  &__referenceText {
    margin-top: 2.5rem;

    p {
      margin: 0;
    }

    &__link {
      color: $color__fst__cyan__100;
      cursor: pointer;
    }
  }
}

h3.construction-rating {
  margin-top: 2rem;

  @include breakpoint-down($md) {
    margin-top: 3rem;
  }
}

.oring-table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 1rem;

  &.half-width {
    width: 50%;
  }

  &.third-width {
    width: 33.3333%;
  }

  th, td {
    font-weight: $base-text-font-weight-light;
    padding: 0.875rem;
    word-break: break-word;
  }

  td:first-child {
    width: 10rem;
    border-right: 0.0625rem solid $color__primary;
    text-align: left;
    color: $color__primary;
  }

  th:not(:first-child), td:not(:first-child) {
    width: calc((100% - 10rem) / 6);
  }

  th {
    border-bottom: 0.0625rem solid $color__primary;
    text-align: left;
    color: $color__primary;
  }

  td {
    padding: 1.2rem 0.875rem;
    border: none;
    border-bottom: 0.1875rem solid $color__fst__gray__020;

    &.divider {
      border-right: 0.0625rem solid $color__primary;
    }
  }

  .rating-red {
    color: $color__fst__error__contrast;
  }

  .rating-yellow {
    color: $color__fst__warning__contrast;
  }

  .rating-green {
    color: $color__fst__success__contrast;
  }
}

// Mobile/Desktop visibility classes
.desktop-only {
  display: block !important;

  @include breakpoint-down($md) {
    display: none !important;
  }
}

.mobile-only {
  display: none !important;

  @include breakpoint-down($md) {
    display: block !important;
  }
}

.mobile-cards {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.mobile-card {
  box-shadow: 0 0 0.375rem $color__fst__gray__29;
  border-radius: 0;
  padding: 1rem;
  background-color: $color__white;
  margin: 0;

  &__title {
    margin: 0 0 1rem;
    font-size: 1rem;
    font-weight: $base-text-font-weight-semi-bold;
    color: $color__primary;
    padding-bottom: 0.5rem;
  }

  &__content {
    display: flex;
    flex-direction: column;
  }

  &__row {
    display: grid;
    grid-template-columns: 1fr auto 3.5rem 1fr auto;
    align-items: center;
    padding: 0.5rem 0;
    border-bottom: 0.0625rem solid $color__fst__gray__020;

    &:last-child {
      border-bottom: none;
    }

    &--three-col {
      grid-template-columns: 1fr auto 1fr auto 1fr auto;
      gap: 1rem;
    }

    &--vertical {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &__row-item {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
    border-bottom: 0.0625rem solid $color__fst__gray__020;

    @include breakpoint-down($sm) {
      justify-content: space-between;
      width: 100%;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  &__label {
    font-weight: $base-text-font-weight-light;
    font-size: $base-text-font-size;

    // Specific styling for Properties section labels
    &--properties {
      width: 14.5rem;
      min-width: 3rem;
      flex-shrink: 1;
    }
  }

  &__value {
    font-weight: $base-text-font-weight-semi-bold;
    text-align: right;
    min-width: 4rem;
    white-space: nowrap;

    &.rating-red {
      color: $color__fst__error__contrast;
    }

    &.rating-yellow {
      color: $color__fst__warning__contrast;
    }

    &.rating-green {
      color: $color__fst__success__contrast;
    }
  }

  // Combined sections within a single card
  &__section {
    &:not(:last-child) {
      margin-bottom: 1.5rem;
    }
  }

  &__section-title {
    margin: 0 0 0.5rem;
    font-size: $heading-h5-font-size;
    font-weight: $base-text-font-weight-semi-bold;
    color: $color__primary;
  }
}
</style>
